import {
    CommonModule
} from "@angular/common";

import {
    Component,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from "@angular/core";

import {
    MatGridListModule
} from "@angular/material/grid-list";

import {
    TranslateModule
} from "@ngx-translate/core";

import {
    TilbyGesturesDirective
} from "@tilby/tilby-ui-lib/directives/tilby-gestures";

import {
    Categories
} from "tilby-models";

import {
    CashregisterStateService,
    Section
} from "src/app/features";


@Component({
    selector: "app-category-grid",
    templateUrl: "./category-grid.component.html",
    styleUrls: ["./category-grid.component.scss"],
    standalone: true,
    imports: [
        CommonModule,
        MatGridListModule,
        TilbyGesturesDirective,
        TranslateModule
    ]
})
export class CategoryGridComponent implements OnInit, OnChanges {
    protected cashregisterStateService = inject(CashregisterStateService);

    @Input() gridCols = 4;
    @Input({ required: true }) categoriesSet!: Categories[];
    @Input() itemsFavorite = false;
    @Input() customClass = '';
    @Input() fontNameSize: number = 12;
    @Output() categorySelected = new EventEmitter<Categories>();
    @Output() goToSection = new EventEmitter<Section>();

    rowHeight = '48px';
    protected _categorySelected?: Categories | 'favorites';
    @Input() initCategorySelected?: Categories;

    ngOnInit(): void {
        if (this.initCategorySelected) {
            this._categorySelected = this.initCategorySelected;
        } else {
            this._categorySelected = this.itemsFavorite ? 'favorites' : this.categoriesSet[0];
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.fontNameSize) {
            this.fontNameSize = changes.fontNameSize.currentValue;
        }
    }

    emitCategorySelection(category: Categories) {
        if (this.itemsFavorite && category.id === -1) {
            this._categorySelected = 'favorites';
            this.goToSection.emit('favorites');
        } else {
            const amount = this.cashregisterStateService.keyboardTotalValue();
            const currentPriceList = this.cashregisterStateService.priceList();

            if (amount && category[`department${currentPriceList == 1 ? '' : currentPriceList}_id` as keyof Categories]) {
                this.cashregisterStateService.addDynamicCategoryItemToSale$.next({
                    price: amount,
                    category: category
                });
            } else {
                this._categorySelected = category;
                this.categorySelected.emit(category);
            }
        }
    }
}
